import { differenceInMinutes } from 'date-fns';
import { Shift } from '../models/shift';
import {
  getFirstShift,
  getJobFromAsDate,
  getJobFromAsUTCDate,
  getJobToAsDate,
  getLastShift,
} from './eligibilityChecks';
import { addTimeZoneOffset } from './removeTimeZoneOffset';

export function getJobStart(shifts: Shift[], date: string): Date {
  let firstShift = getFirstShift(shifts);
  return addTimeZoneOffset(getJobFromAsDate(date, firstShift.from));
}

export function getJobEnd(shifts: Shift[], date: string): Date {
  let firstShift = getFirstShift(shifts);
  let lastShift = getLastShift(shifts);
  return addTimeZoneOffset(getJobToAsDate(date, firstShift.from, lastShift.to));
}

export function getRawJobStart(shifts: Shift[], date: string): Date {
  let firstShift = getFirstShift(shifts);
  return getJobFromAsUTCDate(date, firstShift.from);
}

export function getRawJobEnd(shifts: Shift[], date: string): Date {
  let firstShift = getFirstShift(shifts);
  let lastShift = getLastShift(shifts);
  return getJobToAsDate(date, firstShift.from, lastShift.to);
}

export function getJobDurationMinutes(shifts: Shift[], date: string): number {
  let start = getRawJobStart(shifts, date);
  let end = getRawJobEnd(shifts, date);
  return differenceInMinutes(end, start);
}
